var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1207"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1207"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34988",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};